// extracted by mini-css-extract-plugin
export default {"card":"b7-z"};